"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaStrategy = exports.defaultMediaStrategyStateInUploadView = exports.defaultMediaStrategyState = void 0;
var MediaItem_1 = require("../MediaItem");
var MediaItemFilterName_1 = require("../MediaItemFilterName");
var addPaddingToImage_1 = require("../MediaLibrary/addPaddingToImage");
var toCropAreaState_1 = require("../MediaLibrary/ImageEditor/toCropAreaState");
exports.defaultMediaStrategyState = {
    view: 'list',
    mediaItems: [],
    mediaConstraints: null,
    isLoadingMediaItems: true,
    isLoadingMediaConstraints: false,
    isUploadingMedia: false,
    file: null,
    selectedImage: null,
};
exports.defaultMediaStrategyStateInUploadView = __assign(__assign({}, exports.defaultMediaStrategyState), { view: 'upload' });
var MediaItemFilterTypesWithSizeBlurbs = [
    'guide_main_image',
    'guide_step_image',
    'wiki_summary_image',
    'work_order_image',
];
var MediaStrategy = /** @class */ (function () {
    function MediaStrategy(state, setState, toast, options) {
        var _this = this;
        this.handleProgress = function (updatedMediaItemId, updatedMediaItem) {
            _this.setState(function (state) { return (__assign(__assign({}, state), { mediaItems: state.mediaItems.map(function (mediaItem) {
                    var isUpdatedMediaItem = (0, MediaItem_1.isUploadingMediaItem)(mediaItem) && mediaItem.tempId === updatedMediaItemId;
                    return isUpdatedMediaItem ? updatedMediaItem : mediaItem;
                }) })); });
        };
        this.state = state;
        this.setState = setState;
        this.toast = toast;
        this.options = options;
    }
    Object.defineProperty(MediaStrategy.prototype, "_js", {
        get: function () {
            return this.options._js;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MediaStrategy.prototype, "view", {
        get: function () {
            return this.state.view;
        },
        enumerable: false,
        configurable: true
    });
    MediaStrategy.prototype.setView = function (view) {
        this.setState(__assign(__assign({}, this.state), { view: view }));
    };
    Object.defineProperty(MediaStrategy.prototype, "mediaItems", {
        get: function () {
            return this.state.mediaItems;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MediaStrategy.prototype, "mediaConstraints", {
        get: function () {
            return this.state.mediaConstraints;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MediaStrategy.prototype, "filter", {
        get: function () {
            return this.options.filter ? this.options.filter : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MediaStrategy.prototype, "siteName", {
        get: function () {
            return this.options.siteName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MediaStrategy.prototype, "selectedImage", {
        get: function () {
            return this.state.selectedImage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MediaStrategy.prototype, "isLoadingMediaItems", {
        get: function () {
            return this.state.isLoadingMediaItems;
        },
        enumerable: false,
        configurable: true
    });
    MediaStrategy.prototype.deleteAllMediaItems = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState(__assign(__assign({}, this.state), { mediaItems: [] }));
                        return [4 /*yield*/, this.handleAllMediaItemsDeleted()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MediaStrategy.prototype.loadMediaItems = function () {
        return __awaiter(this, void 0, void 0, function () {
            var mediaItems;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.handleLoadMediaItems()];
                    case 1:
                        mediaItems = _a.sent();
                        this.setState(function (state) { return (__assign(__assign({}, state), { mediaItems: mediaItems, isLoadingMediaItems: false })); });
                        return [2 /*return*/];
                }
            });
        });
    };
    MediaStrategy.prototype.loadMediaItem = function (type, id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.handleLoadMediaItem(type, id)];
            });
        });
    };
    MediaStrategy.prototype.loadMediaConstraints = function () {
        return __awaiter(this, void 0, void 0, function () {
            var mediaConstraints;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState(__assign(__assign({}, this.state), { isLoadingMediaConstraints: true }));
                        return [4 /*yield*/, this.handleLoadMediaConstraints()];
                    case 1:
                        mediaConstraints = _a.sent();
                        this.setState(function (state) { return (__assign(__assign({}, state), { mediaConstraints: mediaConstraints, isLoadingMediaConstraints: false })); });
                        return [2 /*return*/];
                }
            });
        });
    };
    MediaStrategy.prototype.uploadMediaItem = function (file) {
        return __awaiter(this, void 0, void 0, function () {
            var newMediaItem, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        newMediaItem = {
                            tempId: MediaStrategy.tempIdSerial++,
                            type: 'Uploading',
                            step: 'uploading',
                            progress: null,
                            file: file,
                        };
                        this.setState(function (state) { return (__assign(__assign({}, state), { view: 'list', isUploadingMedia: true, mediaItems: __spreadArray(__spreadArray([], state.mediaItems, true), [newMediaItem], false) })); });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.handleUpload(newMediaItem.tempId, file, this.handleProgress)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this.setState(function (state) { return (__assign(__assign({}, state), { mediaItems: state.mediaItems.filter(function (item) {
                                return !(0, MediaItem_1.isUploadingMediaItem)(item) || item.tempId !== newMediaItem.tempId;
                            }) })); });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    MediaStrategy.prototype.importMediaByUrl = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var newMediaItem;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        newMediaItem = {
                            tempId: MediaStrategy.tempIdSerial++,
                            type: 'Uploading',
                            step: 'uploading',
                            progress: null,
                        };
                        this.setState(function (state) { return (__assign(__assign({}, state), { view: 'list', isUploadingMedia: true, mediaItems: __spreadArray(__spreadArray([], _this.state.mediaItems, true), [newMediaItem], false) })); });
                        if (!(0, MediaItem_1.isImageUrl)(url)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.handleImportImageByUrl(newMediaItem.tempId, url, this.handleProgress)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.handleImportEmbedByUrl(newMediaItem.tempId, url, this.handleProgress)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    MediaStrategy.prototype.deleteMediaItem = function (mediaItem) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState(function (state) { return (__assign(__assign({}, state), { mediaItems: state.mediaItems.filter(function (item) { return item !== mediaItem; }) })); });
                        return [4 /*yield*/, this.handleMediaItemDeleted(mediaItem)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MediaStrategy.prototype.uploadEditedImage = function (file, selectedImage, options) {
        return __awaiter(this, void 0, void 0, function () {
            var mediaItemsWithoutSelectedImage, tempId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        mediaItemsWithoutSelectedImage = this.state.mediaItems.filter(function (item) { return !(0, MediaItem_1.isGuideImage)(item) || item.imageid !== (selectedImage === null || selectedImage === void 0 ? void 0 : selectedImage.image.id); });
                        tempId = MediaStrategy.tempIdSerial++;
                        this.setState(function (state) { return (__assign(__assign({}, state), { view: 'list', selectedImage: null, mediaItems: __spreadArray(__spreadArray([], mediaItemsWithoutSelectedImage, true), [
                                {
                                    tempId: tempId,
                                    type: 'Uploading',
                                    step: 'uploading',
                                    progress: null,
                                    file: file,
                                },
                            ], false) })); });
                        return [4 /*yield*/, this.handleEditedImageUpload(tempId, options, file, this.handleProgress)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MediaStrategy.prototype.markupGuideImage = function (guideImage) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var imageDetails, wrongRatio, alreadyHasMarkup, autoPaddedImageDetails_1;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, this.handleLoadImageDetails(guideImage.imageid)];
                    case 1:
                        imageDetails = _d.sent();
                        wrongRatio = ((_a = imageDetails === null || imageDetails === void 0 ? void 0 : imageDetails.filterInfo) === null || _a === void 0 ? void 0 : _a.ratio) && imageDetails.ratio !== imageDetails.filterInfo.ratio;
                        alreadyHasMarkup = ((_b = imageDetails.markupState) === null || _b === void 0 ? void 0 : _b.edits) || ((_c = imageDetails.markupState) === null || _c === void 0 ? void 0 : _c.annotations);
                        if (!(wrongRatio && alreadyHasMarkup)) return [3 /*break*/, 2];
                        this.setState(function (state) { return (__assign(__assign({}, state), { view: 'crop', selectedImage: imageDetails })); });
                        return [3 /*break*/, 5];
                    case 2:
                        if (!wrongRatio) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.autoPadImage(imageDetails)];
                    case 3:
                        autoPaddedImageDetails_1 = _d.sent();
                        this.setState(function (state) { return (__assign(__assign({}, state), { view: 'markup', selectedImage: autoPaddedImageDetails_1 })); });
                        return [3 /*break*/, 5];
                    case 4:
                        this.setState(function (state) { return (__assign(__assign({}, state), { view: 'markup', selectedImage: imageDetails })); });
                        _d.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    MediaStrategy.prototype.cropGuideImageToRatio = function (guideImage) {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function () {
            var imageDetails, alreadyHasMarkup, autoPaddedImageDetails, blob, mime_1, extension, filename, file, mediaItemFilterName;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0: return [4 /*yield*/, this.handleLoadImageDetails(guideImage.imageid)];
                    case 1:
                        imageDetails = _f.sent();
                        alreadyHasMarkup = ((_a = imageDetails.markupState) === null || _a === void 0 ? void 0 : _a.edits) || ((_b = imageDetails.markupState) === null || _b === void 0 ? void 0 : _b.annotations);
                        if (!alreadyHasMarkup) return [3 /*break*/, 2];
                        this.setState(function (state) { return (__assign(__assign({}, state), { view: 'crop', imageDetails: imageDetails })); });
                        return [3 /*break*/, 7];
                    case 2: return [4 /*yield*/, this.autoPadImage(imageDetails)];
                    case 3:
                        autoPaddedImageDetails = _f.sent();
                        return [4 /*yield*/, fetch(autoPaddedImageDetails.image.original)];
                    case 4: return [4 /*yield*/, (_f.sent()).blob()];
                    case 5:
                        blob = _f.sent();
                        mime_1 = blob.type;
                        extension = mime_1.split('/')[1];
                        filename = (_d = (_c = autoPaddedImageDetails.exif) === null || _c === void 0 ? void 0 : _c.FileName) !== null && _d !== void 0 ? _d : "edited-image-".concat(autoPaddedImageDetails.image.id, ".").concat(extension);
                        file = new File([blob], filename);
                        mediaItemFilterName = this.filter;
                        return [4 /*yield*/, this.uploadEditedImage(file, autoPaddedImageDetails, {
                                imageid: autoPaddedImageDetails.image.id,
                                edits: ((_e = autoPaddedImageDetails.markupState) === null || _e === void 0 ? void 0 : _e.edits) || null,
                                annotations: null,
                                mediaItemFilterName: mediaItemFilterName,
                            })];
                    case 6: return [2 /*return*/, _f.sent()];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    MediaStrategy.prototype.autoPadImage = function (imageDetails) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var suggestedCrop, cropAreaState, htmlImage;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        suggestedCrop = imageDetails.suggestedCrop;
                        cropAreaState = (0, toCropAreaState_1.convertSuggestedCropToCropAreaState)(imageDetails);
                        if (!suggestedCrop || !cropAreaState) {
                            return [2 /*return*/, imageDetails];
                        }
                        return [4 /*yield*/, this.createHtmlImage(imageDetails.image.original)];
                    case 1:
                        htmlImage = _c.sent();
                        return [2 /*return*/, __assign(__assign({}, imageDetails), { srcid: imageDetails.image.id, image: __assign(__assign({}, imageDetails.image), { original: (0, addPaddingToImage_1.addPaddingToImage)(htmlImage, suggestedCrop) }), width: suggestedCrop.width, height: suggestedCrop.height, ratio: (_b = (_a = imageDetails.filterInfo) === null || _a === void 0 ? void 0 : _a.ratio) !== null && _b !== void 0 ? _b : 'VARIABLE', suggestedCrop: undefined, srcImageInfo: imageDetails, markupState: __assign(__assign({}, imageDetails.markupState), { edits: {
                                        type: 'CROPRO',
                                        version: '1',
                                        data: cropAreaState,
                                    } }) })];
                }
            });
        });
    };
    MediaStrategy.prototype.createHtmlImage = function (imageUrl) {
        return new Promise(function (resolve) {
            var htmlImage = document.createElement('img');
            htmlImage.setAttribute('crossOrigin', 'anonymous');
            htmlImage.addEventListener('load', function () {
                resolve(htmlImage);
            });
            htmlImage.src = imageUrl;
        });
    };
    MediaStrategy.prototype.cropGuideImage = function (guideImage) {
        return __awaiter(this, void 0, void 0, function () {
            var selectedImage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.handleLoadImageDetails(guideImage.imageid)];
                    case 1:
                        selectedImage = _a.sent();
                        this.setState(function (state) { return (__assign(__assign({}, state), { view: 'crop', selectedImage: selectedImage })); });
                        return [2 /*return*/];
                }
            });
        });
    };
    MediaStrategy.prototype.copyMediaItem = function (mediaItem) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState(function (state) { return (__assign(__assign({}, state), { isLoadingMediaItems: true })); });
                        return [4 /*yield*/, this.handleCopyMediaItem(mediaItem)];
                    case 1:
                        _a.sent();
                        this.toast({
                            id: 'media-item-copy-success',
                            title: this._js('The media item has been copied to the media manager'),
                            status: 'success',
                            isClosable: true,
                            duration: 5000,
                            position: 'top',
                        });
                        this.setState(function (state) { return (__assign(__assign({}, state), { isLoadingMediaItems: false })); });
                        return [2 /*return*/];
                }
            });
        });
    };
    MediaStrategy.prototype.getMediaItem = function (type, id) {
        var _this = this;
        return this.mediaItems.find(function (item) { return item.type === type && _this.getMediaItemId(item) === id; });
    };
    MediaStrategy.prototype.getMediaItemId = function (item) {
        if ((0, MediaItem_1.isGuideImage)(item))
            return item.imageid;
        if ((0, MediaItem_1.isGuideEmbedObject)(item))
            return item.objectid;
        if ((0, MediaItem_1.isGuideVideoObject)(item))
            return item.objectid;
        if ((0, MediaItem_1.isDocument)(item))
            return item.documentid;
        if ((0, MediaItem_1.isUploadingMediaItem)(item))
            return item.tempId;
        throw Error("Unexpected media item ".concat(JSON.stringify(item)));
    };
    MediaStrategy.prototype.getMediaBlurbs = function () {
        var _a, _b;
        var filetypesBlurb = '';
        var sizeBlurb = '';
        var filetypeString = (_b = (_a = this.mediaConstraints) === null || _a === void 0 ? void 0 : _a.filetypes) === null || _b === void 0 ? void 0 : _b.join(', ');
        if (this.filter) {
            filetypesBlurb = this._js('Acceptable filetypes for this %1 are %2.', (0, MediaItemFilterName_1.displayTextFromFilter)(this._js, this.filter), filetypeString);
            if (MediaItemFilterTypesWithSizeBlurbs.includes(this.filter)) {
                sizeBlurb = this._js('Minimum size for a %1 is 96×72 pixels. Maximum size is 40 MB.', (0, MediaItemFilterName_1.displayTextFromFilter)(this._js, this.filter));
            }
        }
        return {
            filetypesBlurb: filetypesBlurb,
            sizeBlurb: sizeBlurb,
        };
    };
    MediaStrategy.tempIdSerial = 1;
    return MediaStrategy;
}());
exports.MediaStrategy = MediaStrategy;
